import car from '@/assets/img/car.png'
import redCar from '@/assets/img/car_red.png'
import cloudBlue from '@/assets/img/cloud-blue.png'
import cloudGray from '@/assets/img/cloud-gray.png'
import cloudRed from '@/assets/img/cloud-red.png'
import electrical from '@/assets/img/electricalBlue.png'
import redError from '@/assets/img/error-red.png'
import battary0 from '@/assets/img/low-battery.png'
import battary50 from '@/assets/img/medium-battery.png'
import battary100 from '@/assets/img/full-battery.png'
import signal100 from '@/assets/img/full-connection.png'
import signal50 from '@/assets/img/medium-connection.png'
import signal0 from '@/assets/img/no-connection.png'
import yellowError from '@/assets/img/icons-error.png'
import opora from '@/assets/img/icons/opora.png'
import light from '@/assets/img/icons/light-on.png'
import sun from '@/assets/img/icons/sun.png'
import width from '@/assets/img/icons/width.png'

import proc from '@/assets/img/processor.png'
import {
  DetailUnit,
  UnitsMapType,
  TLineUnit,
} from '@/modules/maps/types/unitsMapType'

import { signal, voltage12, voltage24, VoltageEnum } from '@/utils'
import { TypeUltraShortTermForecastId } from '@/utils/meteo'
import { DeviceType } from '@/types/enums'

export const balloonYellow = (
  isError: boolean,
  isLoading: boolean,
  unitData: DetailUnit | UnitsMapType
): string => {
  return `<p style='position: absolute; top: 34%; left: 30%; display: ${isLoading ? 'block' : 'none'}'>Загрузка данных...</p>
          <p style='position: absolute; top: 34%; left: 30%; display: ${isError ? 'block' : 'none'}'>Ошибка</p>
           <div style='${isLoading ? 'filter: blur(3px);' : 'unset'}; ${isError ? 'display: none' : 'block'};'>
             <a class='balloon-link' href=/${unitData?.typeId === DeviceType.photo ? 'photos' : 'devices'}/${unitData?.id}>${unitData?.type} ${unitData?.name}</a>
             <p>${unitData?.address}</p>
             <div style='display: flex; gap: 10px; align-items: center'>
               <img class="img-balloon" src="${yellowError}" height="40" width="40" alt='${unitData?.name}'>
               <p style='color: dodgerblue'>${unitData?.errorMessage ?? 'Потеря связи с модулем'}</p>
             </div>
           </div>`
}

export const balloonRed = (
  isError: boolean,
  isLoading: boolean,
  unitData: DetailUnit | UnitsMapType
): string => {
  return `<p style='position: absolute; top: 34%; left: 30%; display: ${isLoading ? 'block' : 'none'}'>Загрузка данных...</p>
          <p style='position: absolute; top: 34%; left: 30%; display: ${isError ? 'block' : 'none'}'>Ошибка</p>
           <div style='${isLoading ? 'filter: blur(3px);' : 'unset'}; ${isError ? 'display: none' : 'block'};'>
             <a class='balloon-link' href=/${unitData?.typeId === DeviceType.photo ? 'photos' : 'devices'}/${unitData?.id}>${unitData?.type} ${unitData?.name}</a>
             <p>${unitData?.address}</p>
             <div style='display: flex; gap: 10px; align-items: center'>
               <img class="img-balloon" src="${redError}" height="40" width="40" alt='${unitData?.name}'>
               <p style='color: dodgerblue'>${unitData?.errorMessage ?? 'Система не работает'}</p>
             </div>
           </div>`
}

export const balloonGreen = (
  isError: boolean,
  isLoading: boolean,
  unitData: DetailUnit | UnitsMapType
): string => {
  return `<p style='position: absolute; top: 34%; left: 30%; display: ${isLoading ? 'block' : 'none'}'>Загрузка данных...</p>
          <p style='position: absolute; top: 34%; left: 30%; display: ${isError ? 'block' : 'none'}'>Ошибка</p>
           <div style='${isLoading ? 'filter: blur(3px);' : 'filter: unset;'}; ${isError ? 'display: none' : 'display: block;'};'>
             <a class='balloon-link' href=/${unitData?.typeId === DeviceType.photo ? 'photos' : 'devices'}/${unitData?.id}>${unitData.type} ${unitData?.name}</a>
             <p class="tooltip">${unitData?.address}</p>
             <div class="img-container" style='${
               unitData?.smart ||
               unitData?.typeId === DeviceType.photo ||
               unitData?.typeId === DeviceType.dit ||
               unitData?.typeId === DeviceType.video
                 ? 'display: flex'
                 : 'display: none'
             }; gap: 15px; align-items: center; justify-content: center; width: 100%'>
               <div title="Количество модулей в системе" style='${
                 unitData?.typeId === DeviceType.photo ||
                 unitData?.typeId === DeviceType.video ||
                 unitData?.typeId === DeviceType.dit
                   ? 'display: none'
                   : 'display: flex'
               }; gap: 5px; align-items: center; cursor: pointer;'>
                 <img class="img-balloon" src="${proc}" height="30" width="30" alt='${unitData?.name}'>
                 <p style='color: dodgerblue; font-size: 16px'>${unitData?.countModules}</p>
               </div>
               <div title="Уровень GSM сигнала" style='${
                 unitData?.typeId === DeviceType.photo ||
                 unitData?.typeId === DeviceType.video ||
                 unitData?.typeId === DeviceType.dit
                   ? 'display: none'
                   : 'display: flex'
               }; gap: 5px; align-items: center; justify-content: center; cursor: pointer;' >
                 <img class="img-balloon" src="${
                   signal(unitData?.signal ?? 0) === 'low'
                     ? signal0
                     : signal(unitData?.signal ?? 0) === 'medium'
                       ? signal50
                       : signal(unitData?.signal ?? 0) === 'high'
                         ? signal100
                         : signal0
                 }" height="30" width="30" alt='${unitData?.name}'>
                 <p style='color: dodgerblue; font-size: 16px'>${unitData?.signal}%</p>
               </div>
               <div title="Напряжение питания" style='${
                 unitData?.typeId === DeviceType.photo ||
                 unitData?.typeId === DeviceType.video ||
                 unitData?.typeId === DeviceType.dit
                   ? 'display: none'
                   : 'display: flex'
               }; gap: 5px; align-items: center; justify-content: center; cursor: pointer;'>
                 <img class="img-balloon" src="${
                   unitData?.is220v
                     ? electrical
                     : (unitData?.voltage ?? 0) <= VoltageEnum.min
                       ? voltage12(unitData?.voltage ?? 0) === 'low'
                         ? battary0
                         : voltage12(unitData?.voltage ?? 0) === 'medium'
                           ? battary50
                           : voltage12(unitData?.voltage ?? 0) === 'high'
                             ? battary100
                             : battary0
                       : (unitData?.voltage ?? 0) > VoltageEnum.min &&
                           (unitData?.voltage ?? 0) <= VoltageEnum.max
                         ? voltage24(unitData?.voltage ?? 0) === 'low'
                           ? battary0
                           : voltage24(unitData?.voltage ?? 0) === 'medium'
                             ? battary50
                             : voltage24(unitData?.voltage ?? 0) === 'high'
                               ? battary100
                               : battary0
                         : battary0
                 }" height="30" width="30" alt='${unitData?.name}'>
                 <p style='color: dodgerblue; font-size: 16px;'>${Number(unitData?.voltage).toFixed(2)}В</p>
               </div>
               <div title="Состояние подключения" style='display: flex; gap: 5px; align-items: center; cursor: pointer;'>
                 <img class="img-balloon" src="${
                   unitData?.connectionStatus === 1
                     ? cloudBlue
                     : unitData?.connectionStatus === 2
                       ? cloudGray
                       : unitData?.connectionStatus === 3
                         ? cloudRed
                         : cloudRed
                 }" height="30" width="30" alt='${unitData?.name}'>
                 <p style='color: dodgerblue; font-size: 16px'>${
                   unitData?.connectionStatus === 1
                     ? 'В сети'
                     : unitData?.connectionStatus === 2
                       ? 'Не в сети'
                       : unitData?.connectionStatus === 3
                         ? 'Нет соединения'
                         : ''
                 }</p>
               </div>
             </div>
             <div style='display: ${unitData.typeId === DeviceType.meteo && unitData?.ultraShortTermForecastId > 1 ? 'flex' : 'none'}; gap: 5px; align-items: center;'>
               <img class="img-balloon" src="${unitData?.ultraShortTermForecastId === 3 ? redCar : car}" height="30" width="30" alt='${unitData?.name}'>
               <p>${TypeUltraShortTermForecastId[unitData?.ultraShortTermForecastId as keyof typeof TypeUltraShortTermForecastId]}</p>
</div>
           </div>`
}

export const lineGreen = (
  isError: boolean,
  isLoading: boolean,
  unitData: TLineUnit
): string => {
  return `<div style="width: 320px"><p style='position: absolute; top: 34%; left: 30%; display: ${isLoading ? 'block' : 'none'}'>Загрузка данных...</p>
          <p style='position: absolute; top: 34%; left: 30%; display: ${isError ? 'block' : 'none'}'>Ошибка</p>
          <style>.ymaps-2-1-79-balloon__tail {left: 45px !important}</style>
           <div style='${isLoading ? 'filter: blur(3px);' : 'filter: unset;'}; ${isError ? 'display: none' : 'display: block;'};'>
             <a class='balloon-link' href=/devices/${unitData?.id}>${unitData.type} ${unitData?.name}</a>
             <p>${unitData?.address}</p>
             <div style="display: flex; gap: 15px; align-items: center; white-space: nowrap">
             <div style="display: flex; gap: 3px; align-items: center">
                 <img src="${width}" height="15"  alt='${unitData?.name}'/>
                 <span style="color: #0072bc">${unitData?.lightingLength || 0} м</span>
            </div>
            <div style="display: flex; gap: 3px; align-items: center">
                 <img src="${light}" height="15"  alt='${unitData?.name}'/>
                 <span style="color: #0072bc">${unitData?.lightingPoles || 0}</span>
            </div>
            <div style="display: flex; gap: 3px; align-items: center">
                 <img src="${opora}" height="24"  alt='${unitData?.name}'/>
                 <span style="color: #0072bc">${unitData?.lightingLuminaires || 0}</span>
            </div>
            <div style="display: flex; gap: 3px; align-items: center">
                 <img src="${sun}" height="15"  alt='${unitData?.name}'/>
                 <span style="color: #0072bc">${unitData?.lightingPower || 0} кВт</span>
            </div>
</div>
           </div></div>`
}

export type TBalloonHtml = {
  isError: boolean
  isLoading: boolean
  title: string
  titleLink: string
  imgUrl?: string
  description?: string
  connectionStatus?: number | null
  icons?: {
    text: string
    iconSrc: string
    helperText?: string
  }[]
}

const cssStyles = `<style>
/*.ymaps-2-1-79-balloon__tail {left: 45px !important}*/
.ymaps-2-1-79-balloon__tail {left: 122px !important}
.balloon-wrapper {
width: 320px;
}
.balloon-img {
width: 100%;
max-height: 160px;
object-fit: fill;
}
.balloon-links a {
font-size: 14px;
  text-decoration: underline;
  text-underline-offset: 4px;
  color: black;
  &:hover {
    text-decoration: none;
  }
}
.balloon-deckr {
fon-weight: bold;
}
.balloon-footer {
    display: flex;
    justify-content: space-between;
    color: #1e90ff;
}
.balloon-footer span {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
}
.balloon-footer img {
    height: 25px;
}
.balloon-status {
display: flex;
justify-content: center;
align-items: center;
gap: 5px;

font-size: 12px;
}
</style>`

export const getBalloonHtml = ({
  isError,
  isLoading,
  title,
  titleLink,
  imgUrl,
  description,
  icons,
  connectionStatus,
}: TBalloonHtml): string => {
  let connectionStatusText = ''
  if (connectionStatus === 1) {
    connectionStatusText = `<img src="${cloudBlue}" /> В сети`
  }
  if (connectionStatus === 2) {
    connectionStatusText = `<img src="${cloudGray}" />Не в сети`
  }
  if (connectionStatus === 3) {
    connectionStatusText = `<img src="${cloudRed}" /> Нет соединения`
  }
  if (isLoading) {
    return `<div>${cssStyles}<div class="balloon-wrapper">Загрузка данных...</div></div>`
  }
  if (isError) {
    return `<div>${cssStyles}<div class="balloon-wrapper">Ошибка !</div></div>`
  }
  return `<div>
        ${cssStyles}
        <div class="balloon-wrapper">
            ${imgUrl ? `<img class="balloon-img" src="${imgUrl}">` : ''}
            <div class="balloon-links"><a href="${titleLink}">${title}</a></div>
            <p class="balloon-deckr">${description}</p>
            ${
              connectionStatusText || (icons && icons.length)
                ? `<div class="balloon-footer">${
                    icons && icons.length
                      ? icons
                          .map(({ text, iconSrc, helperText }) => {
                            return `<span title="${helperText}"><img src="${iconSrc}" />${text}</span>`
                          })
                          .join('')
                      : ''
                  }${
                    connectionStatusText
                      ? `<p class="balloon-status">${connectionStatusText}</p>`
                      : ''
                  }</div>`
                : ''
            }
        </div>
        </div>`
}
